module.exports = __webpack_public_path__ + "media/assets/images/payments/jcb-1cf117ae406fc286f6042a94fd98c9d0.png";